import { MasterType } from '@/common/model/master/w2Master'

import { useCsvUploadApiForm } from '@/components/container/form/modules/master/csvUpload/csvUploadSchema'
import CsvUploadArea from '@/components/container/form/widgets/csv/CsvUploadArea'
import CsvUploadFormContent from '@/components/container/form/widgets/csv/CsvUploadFormContent'

interface Props {
  siteId: number
  masterType: MasterType
  onClickClose(): void
}

const CsvUploadForm = ({ siteId, masterType, onClickClose }: Props) => {
  const { result, control, errors, onSubmit, reset } = useCsvUploadApiForm(siteId, masterType)

  return (
    <form onSubmit={onSubmit}>
      <CsvUploadFormContent
        result={result}
        reset={reset}
        onClickClose={onClickClose}
        control={control}
        errors={errors}
      >
        <CsvUploadArea siteId={siteId} masterType={masterType} control={control} errors={errors} />
      </CsvUploadFormContent>
    </form>
  )
}

export default CsvUploadForm
